import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import entityBase from "entityBase";

export class task_management extends entityBase {
  team_id: KnockoutObservable<string>;
  req_type: KnockoutObservable<string>;
  request_attachment: KnockoutObservable<string>;
  request_id: KnockoutObservable<string>;
  task_id: KnockoutObservable<string>;
  task_type: KnockoutObservable<string>;
  model: KnockoutObservable<string>;
  serial_no: KnockoutObservable<string>;
  created_dt: KnockoutObservable<Date>;
  created_dttm: KnockoutObservable<any>;
  modified_dt: KnockoutObservable<Date>;
  modified_dttm: KnockoutObservable<string>;
  assigned_date_dt: KnockoutObservable<Date>;
  assigned_date_dttm: KnockoutObservable<any>;
  plan_start_dt: KnockoutObservable<Date>;
  plan_start_date: KnockoutObservable<any>;
  plan_end_dt: KnockoutObservable<Date>;
  plan_end_date: KnockoutObservable<any>;
  old_status: KnockoutObservable<any>;
  status: KnockoutObservable<string>;
  status_simple: KnockoutObservable<string>;
  prioTaskColor: KnockoutObservable<string>;
  slaTaskColor: KnockoutObservable<string>;
  prioTask: KnockoutObservable<string>;
  user_def6: KnockoutObservable<string>;
  user_def7: KnockoutObservable<string>;
  user_def8: KnockoutObservable<string>;
  old_user_def8: string;
  plan_start: KnockoutObservable<any>;
  plan_end: KnockoutObservable<any>;
  name: KnockoutObservable<string>;
  address: KnockoutObservable<string>;
  city: KnockoutObservable<string>;
  service_model: KnockoutObservable<string>;
  description: KnockoutObservable<string>;
  request_description: KnockoutObservable<string>;
  pay_all_to_partner: KnockoutObservable<any>;
  commit_dt: KnockoutObservable<any>;
  commit_dttm: KnockoutObservable<any>;
  ext_assigned_dt: KnockoutObservable<Date>;
  ext_assigned_dttm: KnockoutObservable<any>;
  person_id: KnockoutObservable<string>;
  person_name: KnockoutObservable<string>;

  constructor(item: any) {
    super();

    this.team_id = ko.observable(item?.team_id);

    if (item?.task) {
      this.pay_all_to_partner = ko.observable(item.task.pay_all_to_partner == "Y" ? true : false);
    } else {
      this.pay_all_to_partner = ko.observable(item?.pay_all_to_partner == "Y" ? true : false);
    }

    if (item?.time_commit_view) {
      this.commit_dt = ko.observable(this.formatJSONDate(item.time_commit_view.commit_dttm));
      this.commit_dttm = CustomObservables.formattedDateTimeObservable(this.commit_dt);
    } else if (item?.commit_dttm) {
      this.commit_dt = ko.observable(this.formatJSONDate(item.commit_dttm));
      this.commit_dttm = CustomObservables.formattedDateTimeObservable(this.commit_dt);
    } else {
      this.commit_dttm = ko.observable();
    }
    this.ext_assigned_dt = ko.observable(this.formatJSONDate(item?.ext_assigned_dttm ?? undefined));
    this.ext_assigned_dttm = CustomObservables.formattedDateTimeObservable(this.ext_assigned_dt);

    this.name = ko.observable(item?.name);
    this.address = ko.observable(item?.address);
    this.city = ko.observable(item?.city);
    this.request_attachment = ko.observable(item?.request_attachment).extend({ maxLength: 128 });
    this.req_type = ko.observable(item?.req_type || item?.request?.req_type).extend({ maxLength: 128 });
    this.request_id = ko.observable(item?.request_id).extend({ maxLength: 128 });
    this.task_id = ko.observable(item?.task_id).extend({ maxLength: 128 });
    this.task_type = ko.observable(item?.task_type).extend({ maxLength: 128 });
    this.model = ko.observable(item?.model_id).extend({ maxLength: 128 });
    this.serial_no = ko.observable(item?.serial_id).extend({ maxLength: 128 });
    this.created_dt = ko.observable(this.formatJSONDate(item?.created_dttm));
    this.modified_dt = ko.observable(this.formatJSONDate(item?.modified_dttm));
    this.created_dttm = CustomObservables.formattedDateTimeObservable(this.created_dt);
    this.modified_dttm = CustomObservables.formattedDateTimeObservable(this.modified_dt);

    this.assigned_date_dt = ko.observable(this.formatJSONDate(item?.assigned_date));
    this.assigned_date_dttm = CustomObservables.formattedDateTimeObservable(this.assigned_date_dt);

    this.plan_start_dt = ko.observable(this.formatJSONDate(item?.plan_start_dttm));
    this.plan_start_date = CustomObservables.formattedDateTimeObservable(this.plan_start_dt);
    this.plan_end_dt = ko.observable(this.formatJSONDate(item?.plan_end_dttm));
    this.plan_end_date = CustomObservables.formattedDateTimeObservable(this.plan_end_dt);

    this.service_model = ko.observable(item?.service_model);

    this.plan_start = ko.observable(this.toDateString(item?.plan_start_dttm));
    this.plan_end = ko.observable(this.toDateString(item?.plan_end_dttm));

    if (item?.task_status) {
      if (Array.isArray(item.task_status)) {
        this.status = ko.observable(item.task_status[0]);
      } else {
        this.status = ko.observable(item?.task_status);
      }
    }

    this.status_simple = ko.observable(item?.status);

    this.description = ko.observable(item?.description);

    if (item?.request) {
      this.request_description = ko.observable(item.request.cust_prob_descr);
    } else if (item?.cust_prob_descr) {
      this.request_description = ko.observable(item.cust_prob_descr);
    }

    if (item?.task_status) {
      if (Array.isArray(item.task_status)) {
        this.old_status = ko.observable(item.task_status[0]);
      } else {
        this.old_status = ko.observable(item.task_status);
      }
    }

    this.user_def6 = ko.observable(item?.user_def6);
    this.user_def7 = ko.observable(item?.user_def7);
    this.user_def8 = ko.observable(item?.user_def8);
    this.old_user_def8 = item?.user_def8;
    this.person_id = ko.observable(item?.person_id);
    this.person_name = ko.observable(item?.person_name);

    this.prioTaskColor = ko.observable(item?.user_def8);
    if (item?.global_code_table) {
      this.prioTask = ko.observable(item.global_code_table.description).extend({ maxLength: 128 });
    } else {
      this.prioTask = ko.observable();
    }
    let minimOneDay = (currentDate) => new Date(currentDate().setDate(currentDate().getDate() - 1));
    let minimOneHour = (currentDate) => new Date(currentDate().setDate(currentDate().getHours() - 1));
    let currentTime = () => new Date();
    this.slaTaskColor = ko.pureComputed(() => {
      if (this.plan_end_date < minimOneDay) {
        return "#FF0000";
      } else if (this.plan_end_date < minimOneHour) {
        return "#FF6A00";
      } else if (this.plan_end_date < currentTime) {
        return "#FFD800";
      } else {
        return "#4CFF00";
      }
    }, this);
    this.prioTaskColor = ko.pureComputed(() => {
      switch (item?.user_def8) {
        case "6":
          return "#FF0000";
        case "1":
          return "#FF6A00";
        case "2":
          return "#FFD800";
        case "3":
          return "#FFE97F";
        case "4":
          return "#4CFF00";
        case "5":
          return "#0094FF";
      }
      return "#fff";
    }, this);
  }
}
